export default {
    allow_to_make_payment_in_insurance_visits: "Камсыздандыруу визиттеринде көчүрмө жасоого уруксат берүү",
    insurance_companies: "Камсыздандыруу компаниялар",
    insurance_polis: "Камсыздандыруу полиси",
    limit: "Лимит",
    number: "Номер",
    paid_by_insurance: "Камсыздандыруу тарабынан төлөнгөн",
    paid_by_patient: "Бейтап тарабынан төлөнгөн",
    polis: "Полис",
    polises: "Полистер",
    use_custom_prices_for_insurance: "Камсыздандыруу компаниялары үчүн жеке бааларды колдонуу",
    use_only_in_insurance: "Камсыздандырууда гана колдонуу",
    valid_from: " баштап жарактуу",
    valid_to: " чейин жарактуу",
    visit_should_have_polis_set_in_order_to_use_insurance_payment: "Камсыздандыруу акысын пайдалануу үчүн визиттин камсыздандыруу полиси толтурулушу керек",
}
